import { Td, Tr } from "@chakra-ui/react";
import React, { ReactElement } from "react";
import Role from "./role";
import { TPageTableItem } from "../pages/ebooks-page/types";
import { TPageRowProps, TPageRowColumnProps } from "./page-row.config";
import moment, { MomentInput } from "moment";
import State, { StateType } from "./state";

const PageRowColumn = <P,>({
  column,
  object,
}: TPageRowColumnProps<P>): ReactElement => {
  const value = column.valueTransform
    ? column.valueTransform<P>(object[column.key as keyof P], object)
    : object[column.key as keyof P];
  if (column.type === "date") {
    return (
      <Td style={column.style}>
        {moment(value as MomentInput).format("DD.MM.YY")}
      </Td>
    );
  }
  if (column.type === "image") {
    return (
      <Td style={column.style}>
        <img src={`${value}`} height="60px" width={"40px"} alt="" />
      </Td>
    );
  }
  if (column.type === "state") {
    return (
      <Td style={column.style}>
        <State
          value={value as StateType}
          link={column.link ? column.link(object) : ""}
        />
      </Td>
    );
  }
  if (column.onClick) {
    return (
      <Td
        style={column.style}
        onClick={() => column.onClick && column.onClick(object)}
        cursor="pointer"
        textDecoration="underline"
      >
        {value as string | number}
      </Td>
    );
  }
  return <Td style={column.style}>{value as string | number}</Td>;
};

const PageRow = <P,>({ schema, object }: TPageRowProps<P>): ReactElement => (
  <Tr>
    {schema.map((column: TPageTableItem<P>) =>
      column.roles.length > 0 ? (
        <Role roles={column.roles}>
          <PageRowColumn column={column} object={object} />
        </Role>
      ) : (
        <PageRowColumn column={column} object={object} />
      )
    )}
  </Tr>
);

export default PageRow;
